export type StageMakerView =
  | { kind: "hub" }
  | { kind: "new" }
  | { kind: "edit"; id: string }
  | { kind: "play"; id: string };

export function parseStageMakerPath(pathname: string): StageMakerView {
  const parts = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  if (parts[0] !== "stage-maker") return { kind: "hub" };
  if (parts.length === 1) return { kind: "hub" };
  if (parts[1] === "new") return { kind: "new" };
  const id = decodeURIComponent(parts[1]);
  if (parts[2] === "play") return { kind: "play", id };
  return { kind: "edit", id };
}
